<template>
  <div class="container-fluid">
    <div class="row">
      <header-vpos></header-vpos>
      <div class="col-12 col-md-6 mt-2">
        <div class="d-flex">
          <button
            class="w-25 m-2"
            style="
              background: #1481da;
              border: none;
              height: 40px;
              color: white;
            "
          >
            Cửa hàng
          </button>
          <button
            class="w-25 m-2"
            style="background: #eeeeee; border: none; height: 40px"
          >
            Danh mục
          </button>
          <button
            class="w-25 m-2"
            style="background: #eeeeee; border: none; height: 40px"
          >
            Sản phẩm
          </button>
          <button
            class="w-25 m-2"
            style="background: #eeeeee; border: none; height: 40px"
          >
            Khuyến mãi
          </button>
        </div>
      </div>
      <div class="col-12 col-md-12 mt-2">
        <div class="container-fluid">
          <form class="row">
            <div
              class="col-12 col-md-6 mt-2"
              style="border-right: 1px #f4f4f4 solid"
            >
              <div class="d-flex flex-column">
                <label style="text-align: start; color: #cbcbcb">
                  Tên cửa hàng</label
                >
                <input
                  placeholder="Nhập tên cửa hàng"
                  style="
                    height: 40px;
                    border: none;
                    border-bottom: 1px #cbcbcb solid;
                  "
                  v-model="storeName"
                />
              </div>
              <div class="d-flex flex-column mt-4">
                <label style="text-align: start; color: #cbcbcb">
                  Địa chỉ</label
                >
                <input
                  placeholder="Nhập địa chỉ"
                  style="
                    height: 40px;
                    border: none;

                    border-bottom: 1px #cbcbcb solid;
                  "
                  v-model="address"
                  @blur="geocodeAddress()"
                  @input="handleInput"
                />
                <ul v-if="suggestions.length">
                  <li
                    v-for="(suggestion, index) in suggestions"
                    :key="index"
                    @click="selectSuggestion(suggestion)"
                  >
                    {{ suggestion.description }}
                  </li>
                  <Places
                    v-model="address"
                    :options="options"
                    @change="handleChange"
                    @clear="handleClear"
                  />
                </ul>
              </div>
              <div class="container-fluid p-0 mt-3">
                <div class="row">
                  <div class="col-12 col-md-6 mt-2">
                    <div class="d-flex">
                      <span
                        class="d-flex align-items-center m-2"
                        style="text-align: start; color: #cbcbcb"
                      >
                        Lat:
                      </span>
                      <input
                        placeholder=""
                        style="
                          height: 40px;
                          border: none;
                          border-bottom: 1px #cbcbcb solid;
                        "
                        v-model="latitude"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mt-2">
                    <div class="d-flex">
                      <span
                        class="d-flex align-items-center m-2"
                        style="text-align: start; color: #cbcbcb"
                      >
                        Long:</span
                      >
                      <input
                        placeholder=""
                        style="
                          height: 40px;
                          border: none;

                          border-bottom: 1px #cbcbcb solid;
                        "
                        v-model="longitude"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container-fluid p-0 mt-4">
                <div class="row">
                  <div class="d-flex flex-column">
                    <span style="text-align: start"> Chọn ảnh</span>
                    <div class="d-flex">
                      <div
                        class="drop-zone m-2"
                        @click="handleClick"
                        @dragover.prevent="handleDragOver"
                        @drop.prevent="handleDrop"
                        :class="{ 'drop-zone--over': isDragging }"
                      >
                        <span class="drop-zone__prompt">+</span>
                        <input
                          type="file"
                          class="drop-zone__input"
                          @change="handleFileChange"
                          ref="fileInput"
                          style="display: none"
                          multiple
                        />
                      </div>

                      <!-- Hiển thị các ảnh đã chọn -->
                      <div class="selected-images">
                        <div
                          v-for="(thumbnail, index) in thumbnails"
                          :key="index"
                          class="selected-image-container"
                        >
                          <img :src="thumbnail" class="selected-image" />
                          <span class="delete-icon" @click="deleteImage(index)"
                            >×</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 mt-2">
                <div class="d-flex flex-column">
                  <!-- <label style="text-align: start; color: #cbcbcb">
                    Ngân hàng</label
                  >
                  <select
                    style="height: 40px; border: 1px #cbcbcb solid"
                    v-model="bankCode"
                  >
                    <option v-for="itemBank in listBank" :key="itemBank.ID">
                      {{ itemBank.NAME_VI }}
                    </option>
                  </select> -->

                  <div class="form-group">
                    <div class="select-menu active shadow-sm">
                      <div class="select-btn" @click="toggleMenu">
                        <img
                          :src="selectedIcon ? `${selectedIcon.logo}` : ``"
                          style="width: 50px"
                        />
                        <span
                          class="sBtn-text" 
                          style="color: #cbcbcb; margin-left: 10px"
                          >{{
                            selectedIcon ? selectedIcon.name : "Chọn ngân hàng"
                          }}</span
                        >
                      </div>
                      <div v-if="message" class="text-danger">
                        Vui lòng chọn 1 ngân hàng!
                      </div>

                      <ul class="options" v-show="menuActive">
                        <li
                          class="option"
                          v-for="itemBank in listBank"
                          :key="itemBank.id"
                          @click="selectIcon(itemBank)"
                        >
                          <img :src="itemBank.logo" style="width: 50px" />
                          <div
                            class="d-flex flex-column"
                            style="
                              margin-left: 10px;
                              text-align: start;
                              font-family: system-ui, -apple-system,
                                BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
                                Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue',
                                sans-serif;
                            "
                          >
                            <span
                              class="option-text ml-4"
                              style="color: black; font-size: 14px; font-weight: 600"
                              >{{ itemBank.short_name }}</span
                            >
                            <span
                              class="option-text ml-4"
                              style="color: black; font-size: 12px"
                              >{{ itemBank.short_name }} -
                              {{ itemBank.name }}</span
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="d-flex mt-4">
                  <div class="d-flex flex-column w-50">
                    <label style="text-align: start; color: #cbcbcb">
                      Số tài khoản</label
                    >
                    <input
                      style="height: 40px; border: 1px #cbcbcb solid"
                      v-model="soTaiKhoan"
                      placeholder="Nhập số tài khoản"
                      @blur="searchBank()"
                    />
                  </div>
                  <div
                    class="d-flex flex-column w-50 m-auto"
                    v-if="bankNameShow"
                  >
                    <input
                      class="mt-4"
                      style="
                        height: 40px;
                        border: none;
                        margin-left: 30px;
                        font-weight: 700;
                        background: none;
                      "
                      disabled
                      placeholder="Tên chủ tài khoản"
                      :value="bankName"
                    />
                  </div>
                </div>
                <div class="mt-4" style="text-align: start; line-height: 2">
                  <span style="font-weight: 600"
                    >Tự động chuyển tiền về tài khoản theo giao dịch hoặc số
                    tiền
                  </span>
                  <br />
                  <span
                    ><i
                      >(Số giao dịch dưới 10 phí 2k, từ 10 đến 20 phí 1k, trên
                      20 miễn phí, số tiền dưới 5tr phí 2k, từ 5tr đến 10tr phí
                      1k, trên 10tr miễn phí)</i
                    >
                  </span>
                </div>

                <div
                  class="mt-4 d-flex w-50 justify-content-sm-between"
                  style="text-align: start; line-height: 2"
                >
                  <div class="d-flex flex-column">
                    <div class="d-flex">
                      <input
                        type="radio"
                        id="contactChoice1"
                        v-model="selectedOption"
                        value="transaction"
                        @click="clearInputs"
                      />
                      <label for="contactChoice1" style="padding: 5px"
                        >Giao dịch</label
                      >
                    </div>
                    <input
                      v-if="selectedOption === 'transaction'"
                      style="height: 40px; border: 1px #cbcbcb solid"
                      v-model="numberOfTransactions"
                      placeholder="Nhập số giao dịch"
                    />
                  </div>
                  <div class="d-flex flex-column">
                    <div class="d-flex">
                      <input
                        type="radio"
                        id="contactChoice2"
                        v-model="selectedOption"
                        value="money"
                        @click="clearInputs"
                      />
                      <label for="contactChoice2" style="padding: 5px"
                        >Tiền</label
                      >
                    </div>
                    <input
                      v-if="selectedOption === 'money'"
                      style="height: 40px; border: 1px #cbcbcb solid"
                      v-model="moneyAmount"
                      placeholder="Nhập số tiền"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-2">
              <h4 style="text-align: start; margin-left: 60px">
                Người được quyền tra cứu hoặc thay đổi
              </h4>
              <div
                class="d-flex w-100"
                style="border-bottom: 1px #f4f4f4 solid"
              >
                <div class="d-flex flex-column w-100">
                  <div class="d-flex w-100 mt-4 justify-content-sm-between">
                    <div class="d-flex flex-column w-75 p-2">
                      <input
                        style="height: 40px; border: 1px #cbcbcb solid"
                        placeholder="Nhập họ tên "
                        v-model="nameQuyen"
                      />
                    </div>
                    <div class="d-flex flex-column w-75 p-2">
                      <input
                        style="height: 40px; border: 1px #cbcbcb solid"
                        placeholder="Nhập số điện thoại"
                        v-model="phoneQuyen"
                      />
                    </div>
                  </div>
                  <div
                    class="p-3 d-flex w-50 justify-content-sm-between"
                    style="text-align: start; line-height: 2"
                  >
                    <div class="d-flex">
                      <input
                        type="checkbox"
                        id="contactChoice1"
                        v-model="traCuuChecked"
                        @change="handleTraCuuChange"
                      />
                      <label for="contactChoice1" style="padding: 5px"
                        >Tra cứu</label
                      >
                    </div>

                    <div class="d-flex">
                      <input
                        type="checkbox"
                        id="contactChoice2"
                        v-model="thayDoiChecked"
                        @change="handleThayDoiChange"
                      />
                      <label for="contactChoice2" style="padding: 5px"
                        >Thay đổi</label
                      >
                    </div>
                  </div>
                </div>
                <div class="w-25 p-5"><img :src="imageUrls.iconDele" /></div>
              </div>
              <div class="m-auto mt-4">
                <button
                  class="w-25"
                  style="
                    border: 2px #1481da solid;
                    color: #1481da;
                    height: 40px;
                    background: none;
                    border-radius: 15px;
                  "
                >
                  <i class="fa fa-plus-circle" aria-hidden="true"></i> Thêm
                  người
                </button>
                <!-- <button @click="postAnh" type="button">Đẩy ảnh</button> -->
              </div>
              <div class="d-flex justify-content-around w-100 p-2 mt-5">
                <input
                  class="w-25"
                  style="height: 40px; border: 1px #cbcbcb solid"
                  placeholder="Nhập 6 số token"
                  v-model="token"
                />
                <button
                  class="w-50"
                  type="button"
                  style="
                    border: 2px #1481da solid;
                    color: white;
                    height: 40px;
                    background: #1481da;
                    border-radius: 15px;
                  "
                  @click="taoCuaHang()"
                >
                  Tạo cửa hàng
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gmapsInit from "@/components/js/googleApi.js";
import HeaderVpos from "../Home/HeaderVpos/HeaderVpos.vue";
import axios from "axios";
import { Places } from "vue-places";
import { imageUrls } from "@/components/js/urlImg";
// import _ from 'lodash';
import {
  convertToBase64,
  getMD5,
  KEY_PHONE_ID,
  KEY_SESSION_ID,
  postCreatesStore,
  postImage,
  // postCreatesStore,
  postSearchBank,
} from "@/components/js/VposService";
export default {
  name: "AddressInput",

  components: { HeaderVpos },
  data() {
    return {
      imageUrls: imageUrls,
      address: "",
      latitude: "",
      longitude: "",
      options: {},
      suggestions: [],
      files: [],
      thumbnails: [],
      isDragging: false,
      maxFiles: 5,
      listBank: [],
      bankNameShow: false,

      nameQuyen: "",
      phoneQuyen: "",
      traCuuChecked: false,
      thayDoiChecked: false,

      token: "",
      storeName: "",
      storeAdd: "",
      storeCode: "",
      soTaiKhoan: "",
      bankCode: "",
      bankName: "",
      concatenatedURLs: "",
      email: "",
      sdt: "",
      rShowName: "",
      rMarName: "",
      rShow: "",
      rMar: "",

      selectedOption: "", // This will hold the selected option
      numberOfTransactions: "", // This will hold the value for number of transactions
      moneyAmount: "",

      menuActive: false, // Thêm menuActive vào data
      selectedIcon: null, // Thêm selectedIcon vào data

      image_key: "",
      imgKeyLogo: "",
      nameBank: "",
    };
  },
  mounted() {
    this.initSearch();
    this.fetchDataBank();
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;
    },
    selectIcon(itemBank) {
      this.selectedIcon = itemBank;
      this.imgKeyLogo = itemBank.logo;
      this.nameBank = itemBank.name;
      this.bankCode = itemBank.code;
      this.menuActive = false;
    },
    clearInputs() {
      this.numberOfTransactions = "";
      this.moneyAmount = "";
    },
    handleTraCuuChange() {
      if (this.traCuuChecked) {
        this.rShowName = this.nameQuyen;
        this.rShow = this.phoneQuyen;
      } else {
        this.rShowName = "";
        this.rShow = "";
      }
    },
    handleThayDoiChange() {
      if (this.thayDoiChecked) {
        this.rMarName = this.nameQuyen;
        this.rMar = this.phoneQuyen;
      } else {
        this.rMarName = "";
        this.rMar = "";
      }
    },
    async handleInput() {
      if (!this.address) {
        this.suggestions = [];
        return;
      }

      try {
        const response = await Places.autocomplete.getPlacePredictions({
          input: this.address,
        });

        this.suggestions = response.predictions;
      } catch (error) {
        console.error("Đã xảy ra lỗi khi lấy gợi ý địa chỉ:", error);
      }
    },
    selectSuggestion(suggestion) {
      this.address = suggestion.description;
      this.suggestions = [];
    },
    async geocodeAddress() {
      try {
        const response = await axios.get(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
            this.address
          )}`
        );
        if (response.data && response.data.length > 0) {
          const { lat, lon } = response.data[0];
          this.latitude = lat;
          this.longitude = lon;
          console.log("Latitude:", lat);
          console.log("Longitude:", lon);
          // Ở đây bạn có thể làm gì đó với tọa độ như lưu vào một biến khác hoặc gửi đến server
        } else {
          console.error("Không tìm thấy tọa độ cho địa chỉ này.");
        }
      } catch (error) {
        console.error("Đã xảy ra lỗi khi lấy tọa độ:", error);
      }
    },
    async initSearch() {
      try {
        const google = await gmapsInit();
        // Lấy đối tượng input cho Autocomplete
        const inputElement = document.getElementById("inputAddress");
        var autocomplete1 = new google.maps.places.Autocomplete(
          inputElement,
          this.options
        );
        console.log(autocomplete1);
      } catch (error) {
        console.log("Đã xảy ra lỗi khi tải Google Maps:", error);
      }
    },

    handleClick() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFiles = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        if (this.files.length < this.maxFiles) {
          this.files.push(file);
          if (file.type.startsWith("image/")) {
            this.createThumbnail(file);
          } else {
            this.thumbnails.push("");
          }
        } else {
          alert("Bạn chỉ có thể chọn tối đa " + this.maxFiles + " ảnh.");
          break;
        }
      }
    },
    handleDragOver(event) {
      event.preventDefault();
      this.isDragging = true;
    },
    handleDrop(event) {
      event.preventDefault();
      this.isDragging = false;
      const droppedFiles = event.dataTransfer.files;
      for (let i = 0; i < droppedFiles.length; i++) {
        const file = droppedFiles[i];
        if (this.files.length < this.maxFiles) {
          this.files.push(file);
          if (file.type.startsWith("image/")) {
            this.createThumbnail(file);
          } else {
            this.thumbnails.push("");
          }
        } else {
          alert("Bạn chỉ có thể thả tối đa " + this.maxFiles + " ảnh.");
          break;
        }
      }
    },
    createThumbnail(file) {
      const thumbnailURL = URL.createObjectURL(file);
      this.thumbnails.push(thumbnailURL);
    },
    deleteImage(index) {
      this.thumbnails.splice(index, 1);
      this.files.splice(index, 1);
    },

    fetchDataBank() {
      import("@/components/json/bankJson.json").then((module) => {
        const data = JSON.parse(JSON.stringify(module.default));
        this.listBank = data;
        // this.articles = data.filter(article => article.img_cn);
      });
    },
    async searchBank() {
      var session = KEY_SESSION_ID;
      var keyPhone = KEY_PHONE_ID;
      if (this.bankCode || this.soTaiKhoan) {
        this.bankCode = this.bankCode.split("-")[0];
        try {
          const res = await postSearchBank(
            keyPhone,
            session,
            this.soTaiKhoan,
            this.bankCode.trim(),
            ""
          );
          console.log(res);
          this.bankNameShow = true;
          this.bankName = res.result.tenChuTK;
        } catch (error) {
          console.log(error);
        }
      } else {
        this.bankNameShow = false;
        alert("Vui lòng nhập số tài khoản");
      }
    },

    async postAnh() {
      try {
        const imgURLs = [];
        for (const thumbnail of this.thumbnails) {
          console.log(thumbnail + " aaaaaa");
          const value = await convertToBase64(thumbnail);
          console.log("vlaue " + value);
          const idCheck = await getMD5(convertToBase64(thumbnail));
          console.log("base64String: " + idCheck);
          const res = await postImage(value, idCheck);
          console.log(res);
          imgURLs.push(res.result); // Giả sử res trả về một đối tượng với thuộc tính imgURL chứa đường dẫn của ảnh
        }
        this.concatenatedURLs = imgURLs.join(";");
        console.log("aaaa " + this.concatenatedURLs);
      } catch (e) {
        console.log(e);
        alert("Lỗi đẩy ảnh");
      }
    },
    async taoCuaHang() {
      var sessionLogin = KEY_SESSION_ID;
      var idLogin = KEY_PHONE_ID;
      var idParent = "";
      // var numberOfTransactions = 50;
      var typeWithDrawMoney = 1;
      this.sdt = KEY_PHONE_ID;

      this.postAnh();
  

      try {
        const res = await postCreatesStore(
          sessionLogin,
          idLogin,
          this.token,
          this.storeName,
          this.address,
          this.storeCode,
          idParent,
          this.totalLimitlogo,
          typeWithDrawMoney,
          this.numberOfTransactions,
          this.totalTables,
          this.concatenatedURLs,
          this.email,
          this.sdt,
          this.bankCode.trim(),
          this.soTaiKhoan,
          this.latitude,
          this.longitude,
          this.rShowName,
          this.rMarName,
          this.rShow,
          this.rMar
        );
        console.log(res);
        if (res.msgCode == 1 && res.msgCode != null) {
          alert("Tạo cửa hàng " + this.storeName + " thành công ! ");
          this.$router.push('/vpos')
        } else {
          alert(res.msgContent);
        }
      } catch (erro) {
        console.log(erro);
      }
    },
  },
};
</script>
<style>
.drop-zone {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: "Quicksand", sans-serif;
  font-weight: 500;
  font-size: 30px;
  cursor: pointer;
  color: #088dc2;
  border: 1px solid #088dc2;
  border-radius: 10px;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #cccccc;
  background-size: cover;
  background-position: center;
  position: relative;
}

.drop-zone__thumb::after {
  content: attr(data-label);
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.75);
  font-size: 14px;
  text-align: center;
}
.selected-images {
  display: flex;
  flex-wrap: wrap;
  background-size: cover;
  background-position: center;
}

.selected-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin: 5px;
}
.selected-image-container {
  position: relative;
  display: inline-block;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 25px;
  width: 25px;
  background-color: rgb(201 201 201 / 70%);
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
}
</style>